import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {CuponsService} from "../../superadmin/services/cupons.service";
import {GridCuponsComponent} from "./grid-cupons/grid-cupons.component";
import {ConstantsService} from "../../fidelidade/ConstantsService";
import {EmpresasService} from "../../superadmin/services/empresas.service";


@Component({
  selector: 'app-tela-cupons',
  templateUrl: './tela-cupons.component.html',
  styleUrls: ['./tela-cupons.component.scss']
})
export class TelaCuponsComponent implements OnInit {
  @ViewChild('gridGruponsAtivos',  {static: true} )  gridGruponsAtivos: GridCuponsComponent;
  @Input() exibirTitulo = true;
  empresa: any = {};
  salvandoConfiguracao = false;
  constructor(private cuponsService: CuponsService, private constantsService: ConstantsService,
              private empresasService: EmpresasService) {

  }

  ngOnInit(): void {
    this.constantsService.empresa$.subscribe(empresa => {
      if(empresa) this.empresa = empresa;
    });
    this.carregueCuponsAtivos();
  }

  novoCupom() {
    this.gridGruponsAtivos.criarCupom();
  }

  salveConfiguracaoCupom() {
    this.salvandoConfiguracao = true;
    this.empresasService.atualizeConfiguracoesCupom(this.empresa).then(() => {
      this.salvandoConfiguracao = false;
    }).catch((erro: string) => {
      this.salvandoConfiguracao = false;
      alert(erro);
    });
  }


  private carregueCuponsAtivos() {
    this.gridGruponsAtivos.carregando = true;
    this.cuponsService.listeCupons({ listavel: true }).then( (resposta) => {
      this.gridGruponsAtivos.setCupons(resposta)
    })
  }

}
